// add lazy-load supported
import LazyLoad from "vanilla-lazyload";

let myLazyLoad = new LazyLoad();

// Cover tables
document.addEventListener( 'DOMContentLoaded', function () {
	let table = document.querySelectorAll( 'table' );
	for ( let i = table.length - 1; i >= 0; i -- ) {
		let cover = document.createElement( 'div' );
		cover.classList.add( 'cover-table' );
		table[i].parentNode.insertBefore( cover, table[i] );
		cover.appendChild( table[i] );
	}
} );


// Open Menu
document.addEventListener( 'DOMContentLoaded', function () {
	let burger = document.querySelector( '.burger' );
	let menu = document.querySelector( '.header__nav-mobile > .menu' );
	let isMenuOpen = false;

	burger.addEventListener( 'click', function () {
		isMenuOpen = !isMenuOpen;
		if ( isMenuOpen ) {
			menu.style.display = 'block';
		} else {
			menu.style.display = 'none';
		}
	} );
} );
